<template>
  <a-spin :spinning="!showPage" size="large" tip="检查权限中..." />
  <div class="data-query-page" @click="handleGlobalClick" v-if="showPage">
    <!-- 上半部分：查询表单（可折叠） -->
    <el-collapse v-model="formCollapse" class="collapse-container" accordion>
      <el-collapse-item title="查询条件" name="form">
        <el-card shadow="hover" class="form-card">
          <el-form :model="queryForm" ref="queryFormRef" label-width="100px">
            <el-row :gutter="20">
              <!-- 字段1：雇主 -->
              <el-col :span="6">
                <el-form-item label="雇主">
                  <el-input
                    v-model="queryForm.employer"
                    placeholder="请输入雇主"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- 字段2：邮箱后缀 -->
              <el-col :span="6">
                <el-form-item label="邮箱后缀">
                  <el-input
                    v-model="queryForm.mailSuffix"
                    placeholder="请输入邮箱后缀"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- 字段3：备注 -->
              <el-col :span="6">
                <el-form-item label="备注">
                  <el-select
                    v-model="queryForm.remarks"
                    placeholder="请选择备注"
                    clearable
                    v-loading="lookupLoading.remarks"
                  >
                    <el-option
                      v-for="item in remarkOptions"
                      :key="item.lookupCode"
                      :label="item.lookupValue"
                      :value="item.lookupCode"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 字段4：雇主分类 -->
              <el-col :span="6">
                <el-form-item label="雇主分类">
                  <el-select
                    v-model="queryForm.employerType"
                    placeholder="请选择雇主分类"
                    clearable
                    v-loading="lookupLoading.employerType"
                  >
                    <el-option
                      v-for="item in employerTypeOptions"
                      :key="item.lookupCode"
                      :label="item.lookupValue"
                      :value="item.lookupCode"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 操作按钮 -->
              <el-col :span="24" class="form-buttons">
                <el-button type="primary" @click="handleQuery" :loading="queryLoading">
                  查询
                </el-button>
                <el-button @click="handleReset">重置</el-button>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </el-collapse-item>
    </el-collapse>

    <!-- 下半部分：分页表格（可折叠） -->
    <el-collapse v-model="tableCollapse" class="collapse-container" accordion>
      <el-collapse-item title="数据列表" name="table">
        <el-card shadow="hover" class="table-card">
          <!-- 表格操作按钮 -->
          <div class="table-actions" style="text-align: left !important;">
            <el-button type="primary" icon="Plus" @click="handleAddRow">新增</el-button>
            <el-button type="danger" icon="Delete" @click="handleDeleteRows">删除</el-button>
          </div>

          <!-- 数据表格 -->
          <el-table
            :data="tableData"
            border
            stripe
            ref="tableRef"
            @selection-change="handleSelectionChange"
            v-loading="tableLoading"
            style="width: 100%; margin-top: 10px"
          >
            <!-- 复选框列 -->
            <el-table-column type="selection" width="55"></el-table-column>
                        
            <!-- 操作列 -->
            <el-table-column class="row-actions" label="操作" width="100">
              <template #default="scope">
                <el-button
                  type="primary"
                  size="small"
                  @click="handleEditRow(scope.row)"
                  v-if="!scope.row.isEditing"
                   class="edit-row-edit-btn"
                >
                  编辑
                </el-button>
                <el-button
                  type="success"
                  size="small"
                  @click="handleSaveRow(scope.row)"
                  class="edit-row-save-btn"
                  v-else
                >
                  保存
                </el-button>
              </template>
            </el-table-column>

            <!-- 雇主列 -->
            <el-table-column label="雇主" prop="employer" min-width="180">
              <template #default="scope">
                <el-input
                  v-if="scope.row.isEditing"
                  v-model="scope.row.employer"
                  placeholder="请输入雇主"
                ></el-input>
                <span v-else>{{ scope.row.employer || '-' }}</span>
              </template>
            </el-table-column>
            
            <!-- 邮箱后缀列 -->
            <el-table-column label="邮箱后缀" prop="mailSuffix" min-width="180">
              <template #default="scope">
                <el-input
                  v-if="scope.row.isEditing"
                  v-model="scope.row.mailSuffix"
                  placeholder="请输入邮箱后缀"
                ></el-input>
                <span v-else>{{ scope.row.mailSuffix || '-' }}</span>
              </template>
            </el-table-column>
            
            <!-- 备注列 -->
            <el-table-column label="备注" prop="remarks" min-width="180">
              <template #default="scope">
                <el-select
                  v-if="scope.row.isEditing"
                  v-model="scope.row.remarks"
                  placeholder="请选择备注"
                  v-loading="lookupLoading.remarks"
                >
                  <el-option
                    v-for="item in remarkOptions"
                    :key="item.lookupCode"
                    :label="item.lookupValue"
                    :value="item.lookupCode"
                  ></el-option>
                </el-select>
                <span v-else>
                  {{ (remarkOptions.find(item => item.lookupCode === scope.row.remarks)?.lookupValue) || '-' }}
                </span>
              </template>
            </el-table-column>
            
            <!-- 雇主分类列 -->
            <el-table-column label="雇主分类" prop="employerType" min-width="180">
              <template #default="scope">
                <el-select
                  v-if="scope.row.isEditing"
                  v-model="scope.row.employerType"
                  placeholder="请选择雇主分类"
                  v-loading="lookupLoading.employerType"
                >
                  <el-option
                    v-for="item in employerTypeOptions"
                    :key="item.lookupCode"
                    :label="item.lookupValue"
                    :value="item.lookupCode"
                  ></el-option>
                </el-select>
                <span v-else>
                  {{ (employerTypeOptions.find(item => item.lookupCode === scope.row.employerType)?.lookupValue) || '-' }}
                </span>
              </template>
            </el-table-column>

          </el-table>

          <!-- 分页控件 -->
          <el-pagination
            style="margin-top: 20px; text-align: right"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            v-model:current-page="pagination.currentPage"
            v-model:page-size="pagination.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :total="pagination.total"
            layout="total, sizes, prev, pager, next, jumper"
          ></el-pagination>
        </el-card>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, onUnmounted, nextTick } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import openAtomApi from '@/openAtomApi';
import axios from 'axios';

const showPage = ref(false);
const user = ref({});
onMounted(async () => {
  try {
    // 先拉取用户信息，再进行权限校验
    const openAtomRes = await openAtomApi.get('/user/info');
    user.value = openAtomRes.data || {};
    const res = await axios.post('/requestHeader/checkPermissions', null, {
      params: {
        userId: user.value.id,
        opRequestHeaderId: null,
        operationCode: 'LOCK',
      }
    });
    if (res.data.code !== 200) {
      throw new Error(res.data.desc);
    }
  } catch (err) {
    if (err.response?.status === 403) {
      window.location.href = '/403';
    } else {
      console.error('Failed to fetch user info:', err);
      window.location.href = '/500';
    }
  }
  showPage.value = true;
});

const API = {
  LOOKUP: '/requestHeader/queryLookup',
  LIST: '/managerController/getEmployerListBypage',
  SAVE: '/managerController/saveEmployer',
  DELETE: '/managerController/deleteEmployerList'
};

const LOOKUP_TYPES = {
  remarks: 'OP_EMPLOYER_REMARK',
  employerType: 'OP_EMPLOYER_TYPE'
};

const editingRow = ref(null);
const formCollapse = ref(['form']);
const tableCollapse = ref(['table']);

const queryFormRef = ref(null);
const queryForm = reactive({
  employer: '',
  mailSuffix: '',
  remarks: '',
  employerType: ''
});

const REQUIRED_FIELDS = [
  { key: 'employer', label: '雇主' },
  { key: 'mailSuffix', label: '邮箱后缀' },
  { key: 'remarks', label: '备注' },
  { key: 'employerType', label: '雇主分类' }
];

const pagination = reactive({
  currentPage: 1,
  pageSize: 10,
  total: 0
});

const tableRef = ref(null);
const tableData = ref([]);
const selectedRows = ref([]);
const queryLoading = ref(false);
const tableLoading = ref(false);

const remarkOptions = ref([]);
const employerTypeOptions = ref([]);
const lookupLoading = reactive({
  remarks: false,
  employerType: false
});

onMounted(() => {
  fetchLookupOptions('remarks', remarkOptions);
  fetchLookupOptions('employerType', employerTypeOptions);
});

// 监听组件卸载，清理编辑状态
onUnmounted(() => {
  editingRow.value = null;
});

async function fetchLookupOptions(type, target) {
  lookupLoading[type] = true;
  try {
    const res = await axios.post(API.LOOKUP, null, {
      params: {
        lookupType: LOOKUP_TYPES[type],
        lookupCode: '',
        language: 'zh'
      }
    });
    if (res.data.code !== 200) {
      throw new Error(res.data.desc);
    }
    target.value = res.data.data || [];
  } catch (error) {
    ElMessage.error(`加载${type}选项失败`);
    console.error('获取下拉选项失败:', error);
  } finally {
    lookupLoading[type] = false;
  }
}


async function handleQuery() {
  queryLoading.value = true;
  tableLoading.value = true;
  editingRow.value = null;
  try {
    const res = await axios.post(
      `${API.LIST}/${pagination.pageSize}/${pagination.currentPage}`,
      queryForm
    );
    if (res.data?.baseResult?.code !== 200) {
      throw new Error(res.data.desc);
    }
    const list = res.data.baseResult.data || [];
    pagination.pageSize = res.data?.pageVO?.pageSize;
    pagination.currentPage = res.data?.pageVO?.curPage;
    pagination.total = res.data?.pageVO?.totalRows;
    tableData.value = list.map(item => ({
      ...item,
      isEditing: false
    }));
  } catch (error) {
    ElMessage.error('查询失败，请重试');
    console.error('查询数据失败:', error);
    tableData.value = [];
    pagination.total = 0;
  } finally {
    queryLoading.value = false;
    tableLoading.value = false;
  }
}

function handleReset() {
  if (queryFormRef.value) {
    queryFormRef.value.resetFields();
  }
  queryForm.employer = '';
  queryForm.mailSuffix = '';
  queryForm.remarks = '';
  queryForm.employerType = '';
  tableData.value = [];
  pagination.total = 0;
  pagination.currentPage = 1;
}

function handleSelectionChange(val) {
  selectedRows.value = val;
}

function handleGlobalClick(e) {
  if (!editingRow.value) return;
  
  const isClickInForm = e.target.closest('.form-card') || e.target.closest('.table-actions');
  if (isClickInForm) return;

  const isClickSaveBtn = e.target.closest('.edit-row-save-btn');
  const isClickEditBtn = e.target.closest('.edit-row-edit-btn');
  if (isClickSaveBtn || isClickEditBtn) return;

  const isClickInEditRow = e.target.closest('.el-table__row[class*="hover-row"]')
    || e.target.closest('.el-input')
    || e.target.closest('.el-select');

  if (!isClickInEditRow) {
    confirmSaveEditingRow();
  }
}

async function confirmSaveEditingRow() {
  try {
    await ElMessageBox.confirm(
      '您正在编辑该行数据，点击其他区域将触发保存，是否确认保存？',
      '提示',
      {
        confirmButtonText: '保存',
        cancelButtonText: '取消',
        type: 'warning'
      }
    );
    await handleSaveRow(editingRow.value);
  } catch (error) {
    if (error !== 'cancel') {
      ElMessage.error('保存失败，请重试');
      console.error('保存失败:', error);
    } else {
      Object.assign(editingRow.value, editingRow.value.originalData);
      editingRow.value.isEditing = false;
      delete editingRow.value.originalData;
      editingRow.value = null;
      await handleQuery();
      ElMessage.info('已取消保存，表格数据已刷新');
    }
  }
}

function handleEditRow(row) {
  if (editingRow.value && editingRow.value.id !== row.id) {
    confirmSaveEditingRow();
  }
  row.originalData = { ...row };
  row.isEditing = true;
  editingRow.value = row;
}

async function handleSaveRow(row) {
  const emptyFields = [];
  REQUIRED_FIELDS.forEach(({ key, label }) => {
    const value = row[key]?.toString().trim() || '';
    if (value === '') {
      emptyFields.push(label);
    }
  });

  if (emptyFields.length > 0) {
    ElMessage.error(`请填写必填字段：${emptyFields.join('、')}`);
    return;
  }
  try {
    const res = await axios.post(API.SAVE, row);
    if (res.data.code === 200) {
      ElMessage.success('保存成功');
      row.isEditing = false;
      delete row.originalData;
      editingRow.value = null;
      handleQuery();
    } else {
      ElMessage.error('保存失败：' + (res.data.msg || '服务器错误'));
    }
  } catch (error) {
    ElMessage.error('保存失败，请重试');
    console.error('保存行数据失败:', error);
  }
}

function handleAddRow() {
  if (editingRow.value) {
    ElMessage.warning('请先保存或取消当前编辑');
    return;
  }
  const newRow = {
    id: '',
    employer: '',
    mailSuffix: '',
    remarks: '',
    employerType: '',
    isEditing: true
  };
  tableData.value.unshift(newRow);
  editingRow.value = newRow;
  nextTick(() => {
    if (tableRef.value) {
      tableRef.value.setCurrentRow(newRow);
    }
  });
}

async function handleDeleteRows() {
  if (selectedRows.value.length === 0) {
    ElMessage.warning('请至少选择一行数据');
    return;
  }

  try {
    await ElMessageBox.confirm(
      '确定要删除选中的行数据吗？',
      '删除确认',
      {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'danger'
      }
    );

    const ids = selectedRows.value
      .map(row => row.id)
      .filter(id => id && id.trim() !== '');
    
    if (ids.length > 0) {
      await axios.post(API.DELETE, ids);
    }
    
    tableData.value = tableData.value.filter(
      row => !selectedRows.value.some(selected => selected.id === row.id)
    );
    
    ElMessage.success('删除成功');
    handleQuery();
  } catch (error) {
    if (error !== 'cancel') {
      ElMessage.error('删除失败，请重试');
      console.error('删除数据失败:', error);
    }
  }
}

function handleSizeChange(val) {
  pagination.pageSize = val;
  handleQuery();
}

function handleCurrentChange(val) {
  pagination.currentPage = val;
  handleQuery();
}
</script>

<style scoped>
.data-query-page {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.collapse-container {
  margin-bottom: 20px;
}

/* 表单卡片样式 */
.form-card {
  --el-card-padding: 20px;
  margin-top: 10px;
}

.form-buttons {
  margin-top: 10px;
}

/* 表格卡片样式 */
.table-card {
  --el-card-padding: 20px;
  margin-top: 10px;
}

.table-actions {
  margin-bottom: 10px;
}

/* 响应式适配 */
@media (max-width: 768px) {
  .data-query-page {
    padding: 10px;
  }
  
  .el-row {
    flex-direction: column;
  }
  
  .el-col {
    width: 100% !important;
    margin-bottom: 10px;
  }
}
</style>